import React from 'react';
import ColumnTitle from '~/view/components/ColumnTitle/ColumnTitle';

const T360BranchesMappingTableHeader: React.FC = () => {
  return (
    <div className="t360-branches-mapping-table-header d-flex flex-row px-8">
      <ColumnTitle<string> title="branch_matching_popup_taker_col_name" className="t360-branches-mapping-table-header-taker" />
      <ColumnTitle<string> title="keeta_id" />
    </div>
  );
};

export default T360BranchesMappingTableHeader;
